// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checkout-container{
    display: flex;
    flex-direction: column;
    width: 80%;
    justify-content: left;
    margin-top: 130px;
    margin-left: 10%;
    margin-bottom: 20px;
}

.checkout-container h1{
    text-align: left;
    font-size: xx-large;
    font-weight: 600;
    font-family: 'Raleway',sans-serif;
}

.checkout-container h3{
    text-align: left;;
    font-size: large;
    font-weight: 500;
    font-family: 'Poppins',sans-serif;
    padding:20px;
    background-color:#E42727;
    width:50%;
    color:#fff;
    cursor: pointer;
}

.checkout-row-contaner{
    display: flex;
    flex-direction: row;
    
   

}
.billing-form,.shipping-form{
    display: flex;
    width:80%;
    flex-direction: column;
    padding:50px;
    box-shadow: 0 4px 10px rgba(0,0,0,0.3);
}

.name-section{
    display: grid;
    grid-template-columns: 1fr 1fr;
    margin-right: 10px;
    
    
}



.text-input{
    display: flex;
    flex-direction: column;
    
    text-align: left;
    width:100%;
}

.text-input label{
    font-family: 'Poppins',sans-serif;
    font-size: 16px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-items: center;
}

.text-input label span{
    color:red;
    margin-top: 20px;
    margin-left: 10px;
}

.text-input input{
    width:100%;
    height:45px;
    font-size: 17px;
}

.text-input select{
    width:101%;
    height:45px;
}

.check-box{
    display: flex;

}

.check-box label{
    font-family: 'Poppins',sans-serif;
    /* color:#444; */
}

.couponcode-container{
    width:50%;
    display: flex;
    flex-direction: column;
}
.couponcode-container p{
    display: flex;
    flex-direction: column;
    text-align: left;
    font-family: 'Poppins',sans-serif;
    /* color:#444; */
}

.coupon-code{
    display: flex;
    flex-direction: row;
    align-items: center;

}
.coupon-code input{
    width:50%;
    height:40px;
    margin-right: 10px;
}
.checkout-container-button {

    background-color: #e42727;
    width: 180px;
    height: 50px;
    border-radius: 25px;
    color: #ffffff;
    font-family: 'Philosopher', serif;
    margin-left: 0px;
    margin-top: 20px;
    border: none;
    font-size: 18px;
    position: relative;
        overflow: hidden;
        cursor: pointer;
    
        z-index: 0;
}








.checkout-container-button::after {
    /* this is what all  will be done when mouse outs from the button */
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    background-color: #ffa406;
    z-index: -1;

    transition: 0.3s ease all;
    transform: scale(0, 1);

    /* this is you are to change for diffirent transition; */

    transform-origin: bottom left;
    transition: transform 500ms cubic-bezier(0.86, 0, 0.07, 1);
    transition-timing-function: cubic-bezier(0.86, 0, 0.07, 1);
}



.checkout-container-button:hover::after {
    transform: scale(1, 1);
    transform-origin: top left;
}
.coupon-code button{
    background-color: #E42727;
    margin-left: 20px;
    border-radius:10px;
    margin-top: 0px;
}
.billing-container{
    display: flex;
    flex-direction: column;
    width:60%;
    
}

.billing-details h1{
    font-size: 20px;
    font-family: 'Philosopher',sans-serif;
    font-weight: 600;
}

.page-info {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.page-info h1 {
    font-family: 'Philosopher', serif;
    font-size: 24px;
    font-weight: 500;
    margin: 0px;
}

.page-info-navigation {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}

.page-info-navigation-icons {
    margin: 10px;
}

.page-info-navigation h5 {
    font-family: 'Philosopher', sans-serif;
    font-size: 14px;
    font-weight: 500;
    margin: 10px;

}

.order-details{
    width:400px;
    height:100%;
    margin-top: 50px;
    box-shadow: 0 4px 10px rgba(0,0,0,0.3);
    padding:40px;
    
    
}

.order-details h5{
    font-family: 'Philosopher',sans-serif;
    font-size: 20px;
    margin:10px;

}

.order-details td{
    font-family: 'Poppins',sans-serif;
    /* color:#444; */
    font-size: 15px;
    letter-spacing: 1px;

}

.order-details table{
    width:100%;

}


.error-message {
    color: red;
    margin:5px 0px;
}


.loader-container{
    height:50vh;
}
.loader {
    position: fixed;
        top: 25%;
        
        left: 50%;
        
        transform: translate(-50%, -50%);
       
        z-index: 1000;
    border: 8px solid #f3f3f3;
   
    border-top: 8px solid #3498db;
    
    border-radius: 50%;
    width: 50px;
    
    height: 50px;
    
    animation: spin 1s linear infinite;
    
    margin: 20px auto;
    
}


.coupons-container {
    padding: 20px;
    max-width: 100%;
    margin: 0 auto;
    text-align: center;
}

.coupons-container h1 {
    margin-bottom: 20px;
    font-size: 2rem;
    color: #333;
}

.coupon-cards {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    gap: 20px;
}

.coupon-card {
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    width: 200px;
    padding: 20px;
    text-align: left;
    transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
}

.coupon-card h2 {
    margin: 0 0 10px;
    font-size: 1.5rem;
    color: #0073e6;
    word-break: break-word;
}

.coupon-card p {
    margin: 5px 0;
    font-size: 1rem;
    color: #555;
}

.coupon-card:hover {
    transform: scale(1.05);
    box-shadow: 0 6px 10px rgba(0, 0, 0, 0.15);
}

@media screen and (max-width:768px){
    .checkout-container {
            display: flex;
            flex-direction: column;
            width: 90vw;
            justify-content: center;
            
            margin-top: 180px;
            margin-left: 5vw;
            margin-bottom: 20px;
        }
        .checkout-row-contaner {
            display: flex;
            flex-direction: column;
    
    
    
        }
        .billing-form,
        .shipping-form {
            display: flex;
            width: 80%;
            flex-direction: column;
            padding: 10px;
            box-shadow: 0 0 0;
            
        }

        .billing-details, .ship-to-different{
            width:90%;
            
        }

        .couponcode-container {
            width: 90%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            margin:10px 0px;
        }
        
        .billing-container {
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 100%;
            box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
    
        }
        
        .checkout-container h3 {
            text-align: left;
            ;
            font-size: large;
            font-weight: 500;
            font-family: 'Poppins', sans-serif;
            padding: 20px;
            background-color: #E42727;
            width: 90%;
            color: #fff;
        }
       .coupon-code button {
                    background-color: #E42727;
                    margin-left: 20px;
                    border-radius: 10px;
                    margin-top: 0px;
                    width:120px;
                    margin-bottom: 0px;
                }
        .coupon-code {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content:center;
    
        }
        .coupon-code input {
            width: 50%;
            height: 40px;
            margin-right: 0px;
        }
        .checkout-container .order-details {
            width: 100%;
            height: 100%;
            margin-top: 50px;
            box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
            padding: 0px;
            margin-left: 0px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            overflow: scroll;
            
            
           
    
    
        }
        .order-details table {
            width: 90%;
            display: block;
            overflow: scroll;
    
        }
        .order-details tr{
            display: block;
            min-width: 250px;
            
        }
        .order-details th{
            min-width: 250px;
            box-sizing: border-box;
        }
        .order-details td{
            min-width:250px;
        }
}
`, "",{"version":3,"sources":["webpack://./src/Styles/Checkout.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,qBAAqB;IACrB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,iCAAiC;AACrC;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,iCAAiC;IACjC,YAAY;IACZ,wBAAwB;IACxB,SAAS;IACT,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;;;;AAIvB;AACA;IACI,aAAa;IACb,SAAS;IACT,sBAAsB;IACtB,YAAY;IACZ,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;;;AAGtB;;;;AAIA;IACI,aAAa;IACb,sBAAsB;;IAEtB,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,iCAAiC;IACjC,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,aAAa;;AAEjB;;AAEA;IACI,iCAAiC;IACjC,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,iCAAiC;IACjC,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;;AAEvB;AACA;IACI,SAAS;IACT,WAAW;IACX,kBAAkB;AACtB;AACA;;IAEI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,iCAAiC;IACjC,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,kBAAkB;QACd,gBAAgB;QAChB,eAAe;;QAEf,UAAU;AAClB;;;;;;;;;AASA;IACI,mEAAmE;IACnE,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,WAAW;;IAEX,yBAAyB;IACzB,sBAAsB;;IAEtB,wDAAwD;;IAExD,6BAA6B;IAC7B,0DAA0D;IAC1D,0DAA0D;AAC9D;;;;AAIA;IACI,sBAAsB;IACtB,0BAA0B;AAC9B;AACA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;;AAEb;;AAEA;IACI,eAAe;IACf,qCAAqC;IACrC,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,iCAAiC;IACjC,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,sCAAsC;IACtC,eAAe;IACf,gBAAgB;IAChB,YAAY;;AAEhB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,sCAAsC;IACtC,YAAY;;;AAGhB;;AAEA;IACI,qCAAqC;IACrC,eAAe;IACf,WAAW;;AAEf;;AAEA;IACI,iCAAiC;IACjC,gBAAgB;IAChB,eAAe;IACf,mBAAmB;;AAEvB;;AAEA;IACI,UAAU;;AAEd;;;AAGA;IACI,UAAU;IACV,cAAc;AAClB;;;AAGA;IACI,WAAW;AACf;AACA;IACI,eAAe;QACX,QAAQ;;QAER,SAAS;;QAET,gCAAgC;;QAEhC,aAAa;IACjB,yBAAyB;;IAEzB,6BAA6B;;IAE7B,kBAAkB;IAClB,WAAW;;IAEX,YAAY;;IAEZ,kCAAkC;;IAElC,iBAAiB;;AAErB;;;AAGA;IACI,aAAa;IACb,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,wCAAwC;IACxC,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,mEAAmE;AACvE;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,0CAA0C;AAC9C;;AAEA;IACI;YACQ,aAAa;YACb,sBAAsB;YACtB,WAAW;YACX,uBAAuB;;YAEvB,iBAAiB;YACjB,gBAAgB;YAChB,mBAAmB;QACvB;QACA;YACI,aAAa;YACb,sBAAsB;;;;QAI1B;QACA;;YAEI,aAAa;YACb,UAAU;YACV,sBAAsB;YACtB,aAAa;YACb,iBAAiB;;QAErB;;QAEA;YACI,SAAS;;QAEb;;QAEA;YACI,UAAU;YACV,aAAa;YACb,sBAAsB;YACtB,uBAAuB;YACvB,eAAe;QACnB;;QAEA;YACI,aAAa;YACb,sBAAsB;YACtB,mBAAmB;YACnB,WAAW;YACX,yCAAyC;;QAE7C;;QAEA;YACI,gBAAgB;;YAEhB,gBAAgB;YAChB,gBAAgB;YAChB,kCAAkC;YAClC,aAAa;YACb,yBAAyB;YACzB,UAAU;YACV,WAAW;QACf;OACD;oBACa,yBAAyB;oBACzB,iBAAiB;oBACjB,mBAAmB;oBACnB,eAAe;oBACf,WAAW;oBACX,kBAAkB;gBACtB;QACR;YACI,aAAa;YACb,mBAAmB;YACnB,mBAAmB;YACnB,sBAAsB;;QAE1B;QACA;YACI,UAAU;YACV,YAAY;YACZ,iBAAiB;QACrB;QACA;YACI,WAAW;YACX,YAAY;YACZ,gBAAgB;YAChB,yCAAyC;YACzC,YAAY;YACZ,gBAAgB;YAChB,aAAa;YACb,sBAAsB;YACtB,mBAAmB;YACnB,uBAAuB;YACvB,gBAAgB;;;;;;QAMpB;QACA;YACI,UAAU;YACV,cAAc;YACd,gBAAgB;;QAEpB;QACA;YACI,cAAc;YACd,gBAAgB;;QAEpB;QACA;YACI,gBAAgB;YAChB,sBAAsB;QAC1B;QACA;YACI,eAAe;QACnB;AACR","sourcesContent":[".checkout-container{\n    display: flex;\n    flex-direction: column;\n    width: 80%;\n    justify-content: left;\n    margin-top: 130px;\n    margin-left: 10%;\n    margin-bottom: 20px;\n}\n\n.checkout-container h1{\n    text-align: left;\n    font-size: xx-large;\n    font-weight: 600;\n    font-family: 'Raleway',sans-serif;\n}\n\n.checkout-container h3{\n    text-align: left;;\n    font-size: large;\n    font-weight: 500;\n    font-family: 'Poppins',sans-serif;\n    padding:20px;\n    background-color:#E42727;\n    width:50%;\n    color:#fff;\n    cursor: pointer;\n}\n\n.checkout-row-contaner{\n    display: flex;\n    flex-direction: row;\n    \n   \n\n}\n.billing-form,.shipping-form{\n    display: flex;\n    width:80%;\n    flex-direction: column;\n    padding:50px;\n    box-shadow: 0 4px 10px rgba(0,0,0,0.3);\n}\n\n.name-section{\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    margin-right: 10px;\n    \n    \n}\n\n\n\n.text-input{\n    display: flex;\n    flex-direction: column;\n    \n    text-align: left;\n    width:100%;\n}\n\n.text-input label{\n    font-family: 'Poppins',sans-serif;\n    font-size: 16px;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-items: center;\n}\n\n.text-input label span{\n    color:red;\n    margin-top: 20px;\n    margin-left: 10px;\n}\n\n.text-input input{\n    width:100%;\n    height:45px;\n    font-size: 17px;\n}\n\n.text-input select{\n    width:101%;\n    height:45px;\n}\n\n.check-box{\n    display: flex;\n\n}\n\n.check-box label{\n    font-family: 'Poppins',sans-serif;\n    /* color:#444; */\n}\n\n.couponcode-container{\n    width:50%;\n    display: flex;\n    flex-direction: column;\n}\n.couponcode-container p{\n    display: flex;\n    flex-direction: column;\n    text-align: left;\n    font-family: 'Poppins',sans-serif;\n    /* color:#444; */\n}\n\n.coupon-code{\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n\n}\n.coupon-code input{\n    width:50%;\n    height:40px;\n    margin-right: 10px;\n}\n.checkout-container-button {\n\n    background-color: #e42727;\n    width: 180px;\n    height: 50px;\n    border-radius: 25px;\n    color: #ffffff;\n    font-family: 'Philosopher', serif;\n    margin-left: 0px;\n    margin-top: 20px;\n    border: none;\n    font-size: 18px;\n    position: relative;\n        overflow: hidden;\n        cursor: pointer;\n    \n        z-index: 0;\n}\n\n\n\n\n\n\n\n\n.checkout-container-button::after {\n    /* this is what all  will be done when mouse outs from the button */\n    content: \"\";\n    position: absolute;\n    left: 0;\n    top: 0;\n    height: 100%;\n    width: 100%;\n    background-color: #ffa406;\n    z-index: -1;\n\n    transition: 0.3s ease all;\n    transform: scale(0, 1);\n\n    /* this is you are to change for diffirent transition; */\n\n    transform-origin: bottom left;\n    transition: transform 500ms cubic-bezier(0.86, 0, 0.07, 1);\n    transition-timing-function: cubic-bezier(0.86, 0, 0.07, 1);\n}\n\n\n\n.checkout-container-button:hover::after {\n    transform: scale(1, 1);\n    transform-origin: top left;\n}\n.coupon-code button{\n    background-color: #E42727;\n    margin-left: 20px;\n    border-radius:10px;\n    margin-top: 0px;\n}\n.billing-container{\n    display: flex;\n    flex-direction: column;\n    width:60%;\n    \n}\n\n.billing-details h1{\n    font-size: 20px;\n    font-family: 'Philosopher',sans-serif;\n    font-weight: 600;\n}\n\n.page-info {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n\n.page-info h1 {\n    font-family: 'Philosopher', serif;\n    font-size: 24px;\n    font-weight: 500;\n    margin: 0px;\n}\n\n.page-info-navigation {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n}\n\n.page-info-navigation-icons {\n    margin: 10px;\n}\n\n.page-info-navigation h5 {\n    font-family: 'Philosopher', sans-serif;\n    font-size: 14px;\n    font-weight: 500;\n    margin: 10px;\n\n}\n\n.order-details{\n    width:400px;\n    height:100%;\n    margin-top: 50px;\n    box-shadow: 0 4px 10px rgba(0,0,0,0.3);\n    padding:40px;\n    \n    \n}\n\n.order-details h5{\n    font-family: 'Philosopher',sans-serif;\n    font-size: 20px;\n    margin:10px;\n\n}\n\n.order-details td{\n    font-family: 'Poppins',sans-serif;\n    /* color:#444; */\n    font-size: 15px;\n    letter-spacing: 1px;\n\n}\n\n.order-details table{\n    width:100%;\n\n}\n\n\n.error-message {\n    color: red;\n    margin:5px 0px;\n}\n\n\n.loader-container{\n    height:50vh;\n}\n.loader {\n    position: fixed;\n        top: 25%;\n        \n        left: 50%;\n        \n        transform: translate(-50%, -50%);\n       \n        z-index: 1000;\n    border: 8px solid #f3f3f3;\n   \n    border-top: 8px solid #3498db;\n    \n    border-radius: 50%;\n    width: 50px;\n    \n    height: 50px;\n    \n    animation: spin 1s linear infinite;\n    \n    margin: 20px auto;\n    \n}\n\n\n.coupons-container {\n    padding: 20px;\n    max-width: 100%;\n    margin: 0 auto;\n    text-align: center;\n}\n\n.coupons-container h1 {\n    margin-bottom: 20px;\n    font-size: 2rem;\n    color: #333;\n}\n\n.coupon-cards {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: center;\n    gap: 20px;\n}\n\n.coupon-card {\n    background-color: #fff;\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n    width: 200px;\n    padding: 20px;\n    text-align: left;\n    transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;\n}\n\n.coupon-card h2 {\n    margin: 0 0 10px;\n    font-size: 1.5rem;\n    color: #0073e6;\n    word-break: break-word;\n}\n\n.coupon-card p {\n    margin: 5px 0;\n    font-size: 1rem;\n    color: #555;\n}\n\n.coupon-card:hover {\n    transform: scale(1.05);\n    box-shadow: 0 6px 10px rgba(0, 0, 0, 0.15);\n}\n\n@media screen and (max-width:768px){\n    .checkout-container {\n            display: flex;\n            flex-direction: column;\n            width: 90vw;\n            justify-content: center;\n            \n            margin-top: 180px;\n            margin-left: 5vw;\n            margin-bottom: 20px;\n        }\n        .checkout-row-contaner {\n            display: flex;\n            flex-direction: column;\n    \n    \n    \n        }\n        .billing-form,\n        .shipping-form {\n            display: flex;\n            width: 80%;\n            flex-direction: column;\n            padding: 10px;\n            box-shadow: 0 0 0;\n            \n        }\n\n        .billing-details, .ship-to-different{\n            width:90%;\n            \n        }\n\n        .couponcode-container {\n            width: 90%;\n            display: flex;\n            flex-direction: column;\n            justify-content: center;\n            margin:10px 0px;\n        }\n        \n        .billing-container {\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            width: 100%;\n            box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);\n    \n        }\n        \n        .checkout-container h3 {\n            text-align: left;\n            ;\n            font-size: large;\n            font-weight: 500;\n            font-family: 'Poppins', sans-serif;\n            padding: 20px;\n            background-color: #E42727;\n            width: 90%;\n            color: #fff;\n        }\n       .coupon-code button {\n                    background-color: #E42727;\n                    margin-left: 20px;\n                    border-radius: 10px;\n                    margin-top: 0px;\n                    width:120px;\n                    margin-bottom: 0px;\n                }\n        .coupon-code {\n            display: flex;\n            flex-direction: row;\n            align-items: center;\n            justify-content:center;\n    \n        }\n        .coupon-code input {\n            width: 50%;\n            height: 40px;\n            margin-right: 0px;\n        }\n        .checkout-container .order-details {\n            width: 100%;\n            height: 100%;\n            margin-top: 50px;\n            box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);\n            padding: 0px;\n            margin-left: 0px;\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            justify-content: center;\n            overflow: scroll;\n            \n            \n           \n    \n    \n        }\n        .order-details table {\n            width: 90%;\n            display: block;\n            overflow: scroll;\n    \n        }\n        .order-details tr{\n            display: block;\n            min-width: 250px;\n            \n        }\n        .order-details th{\n            min-width: 250px;\n            box-sizing: border-box;\n        }\n        .order-details td{\n            min-width:250px;\n        }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
